import { render, staticRenderFns } from "./RevisionLog.vue?vue&type=template&id=d2fba974"
import script from "./RevisionLog.vue?vue&type=script&lang=js"
export * from "./RevisionLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports